import { RefObject } from "react";
import { createSlice, PayloadAction } from "redux-starter-kit";
import {
  FormSchemaDto,
  EditComponentErrorResponse,
} from "@amzn/crowd-front-end-common-library";
import { MetricsState } from "../logging";
import { validationErrorTextFormatter } from "./types";

type SetPropertyValueAction = PayloadAction<{
  propertyName: string;
  value: unknown;
}>;
type SetNewValueFromParentAction = PayloadAction<{ value: any }>;
type SetFormSchemaAction = PayloadAction<{ value: FormSchemaDto }>;
type SetValidationErrorsAction = PayloadAction<
  EditComponentErrorResponse | undefined
>;

/**
 * Interface that defines the state of a form.
 *
 * @export
 * @interface FormState
 * @template T
 */
export interface FormState<T extends object> {
  originalValue: Partial<T>;
  currentValue: Partial<T>;
  metrics: MetricsState;
  formId: string;
  formSchema?: FormSchemaDto;
  validationErrors?: EditComponentErrorResponse;
  customValidationErrorTextFormatter?: validationErrorTextFormatter<T>;
  refCallback?: (propertyName: string) => RefObject<HTMLElement>;
}

const initialState: FormState<object> = {
  originalValue: {},
  currentValue: {},
  formId: "",
  metrics: {
    config: {
      siteName: "test",
      serviceName: "test",
      isProduction: false,
      sessionId: "",
    },
  },
};

const slice = createSlice({
  initialState,
  reducers: {
    setPropertyValueAction: (state, action: SetPropertyValueAction) => {
      (state.currentValue as Record<string, unknown>)[
        action.payload.propertyName
      ] = action.payload.value;
    },
    setNewValueFromParentAction: (
      state,
      action: SetNewValueFromParentAction
    ) => {
      state.currentValue = action.payload.value;
      state.originalValue = action.payload.value;
    },
    setFormSchema: (state, action: SetFormSchemaAction) => {
      state.formSchema = action.payload.value;
    },
    setFormValidationErrors: (state, action: SetValidationErrorsAction) => {
      state.validationErrors = action.payload;
    },
  },
});

const { actions, reducer } = slice;
export { actions, reducer };
